export default __webpack_public_path__ + "static/paypal-82b7d1fda023fbc72e68ac78228e191f.jpeg";